import './InitiativeSection.scss';
import classNames from 'classnames';
import { getTitleWithCount } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { SonarText } from '@ui/text';
export const InitiativeSection = ({ children, className, count, headerExtra, icon, id, title }) => React.createElement("div", { className: classNames('initiative-section', className), id: id },
    React.createElement(SonarText, { className: 'section-header' },
        icon,
        getTitleWithCount(title, count),
        headerExtra && React.createElement("div", { className: 'header-extra' }, headerExtra)),
    children);
